/* @flow */
import tooltipable from 'lib/tooltipable';
import Glyph from 'components/Glyph.jsx';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import Link from 'components/Link.jsx';
import React from 'react';
import Text from 'components/Text.jsx';
import cx from 'classnames';
import pickGlobalElementProps from 'utils/pickInputElementProps';

import './styles/Token.scss';

class Token extends React.Component {
  static propTypes = {
    color: React.PropTypes.oneOf(['default', 'lava', 'grey', 'white']),
    disabled: React.PropTypes.bool,
    removable: React.PropTypes.bool,
    onRemove: React.PropTypes.func,
    truncate: React.PropTypes.bool,
  };

  static propClasses = {
    color: {
      lava: 'Token-lava',
      grey: 'Token-grey',
      white: 'Token-white',
    },
  };

  static defaultProps = {
    color: 'default',
    disabled: false,
    removable: true,
    truncate: true,
  };

  renderRemove = () => {
    if (!this.props.removable || this.props.disabled) {
      return null;
    }

    return (
      <Link
        className="Token-remove"
        onClick={this.props.onRemove}
        eventElementName="Token-remove">
        <Glyph name="close" size="xxsmall" solo />
      </Link>
    );
  };

  render() {
    const { disabled, className, truncate, children, ...others } = this.props;
    const otherProps = pickGlobalElementProps(others);

    return (
      <div
        {...otherProps}
        className={cx({
          Token: true,
          'Token-disabled': disabled,
        }, getPropClassesFromInstance(this), className)}>
        <Text className="Token-value" truncate={truncate}>
          {children}
        </Text>
        {this.renderRemove()}
      </div>
    );
  }
}

export default tooltipable(Token);



// WEBPACK FOOTER //
// ./src/components/Token.jsx